import { render, staticRenderFns } from "./Rotate5.vue?vue&type=template&id=5c3b6c0b&scoped=true"
import script from "./Rotate5.vue?vue&type=script&lang=js"
export * from "./Rotate5.vue?vue&type=script&lang=js"
import style0 from "./Rotate5.vue?vue&type=style&index=0&id=5c3b6c0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3b6c0b",
  null
  
)

export default component.exports